import React from "react"
import { useState, useCallback } from "react"
import Header from 'app/layout/Header'
import Body from 'app/layout/Body'
import HeaderContext from 'app/HeaderContext'
import { HashRouter } from 'react-router-dom'
import PullToRefresh from 'app/components/PullToRefresh'

export default () => {
  const [text, setText] = useState("Dodo");
  const [contextualMenu, setContextualMenu] = useState(null);

  const headerContextValue = { text, setText, contextualMenu, setContextualMenu };

  const refresh = useCallback(async () => {
    return new Promise((resolve) => {
      window.location.reload();
    });
  })

  return <HeaderContext.Provider value={ headerContextValue }>
           <HashRouter>
             <PullToRefresh onRefresh={refresh}>
               <div id="app" className="bg-landscape-01">
                 <div className="content">
                   <Header text={text} />
                   <Body />
                 </div>
               </div>
             </PullToRefresh>
           </HashRouter>
         </HeaderContext.Provider>
}
